import React from 'react';
import PropTypes from 'prop-types';
import {
  Tabs,
  Tab,
  TabPanel,
  TabList
} from 'react-re-super-tabs';
import { userAuthenticationPageTabs } from '../../../constants';
import RegistrationContainer from '../../RegistrationContainer/RegistrationContainer';
import LoginContainer from '../../loginContainer/loginContainer';
import AuthTab from '../AuthTab/AuthTab';
import * as styles from './AuthTabList.scss';

class AuthTabList extends React.Component {
  renderTab = (type) => (event) =>
    <AuthTab type={type} event={event} onClick={this.props.onTabClick} />;

  render() {
    const { translate, activeTab } = this.props;
    return (
      <Tabs activeTab={activeTab}>
        <TabList id="authenticationTabList" className={styles.tabs}>
          <Tab
            component={this.renderTab(userAuthenticationPageTabs.SIGN_UP)}
            label={translate('authenticationPage', 'registration')()}
            id={userAuthenticationPageTabs.SIGN_UP}
          />
          <Tab
            component={this.renderTab(userAuthenticationPageTabs.SIGN_IN)}
            label={translate('authenticationPage', 'login')()}
            id={userAuthenticationPageTabs.SIGN_IN}
          />
        </TabList>
        <TabList>
          <TabPanel
            component={RegistrationContainer}
            id={userAuthenticationPageTabs.SIGN_UP}
          />
          <TabPanel
            component={LoginContainer}
            id={userAuthenticationPageTabs.SIGN_IN}
          />
        </TabList>
      </Tabs>
    );
  }
}

AuthTabList.propTypes = {
  translate: PropTypes.func,
  activeTab: PropTypes.string,
  onTabClick: PropTypes.func
};

AuthTabList.defaultProps = {
  activeTab: userAuthenticationPageTabs.SIGN_IN
};

export default AuthTabList;
